var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNavBarOwnwellLogo = function SvgNavBarOwnwellLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0a12 12 0 1 0 11.088 7.407A11.992 11.992 0 0 0 12 0Zm6.693 14.566a3.94 3.94 0 0 1-3.946 3.926 3.877 3.877 0 0 1-2.509-.915L12 17.376l-.245.2a3.934 3.934 0 0 1-6.454-3.01v-3.714h2.32v3.682a1.612 1.612 0 0 0 3.218.182v-6.11h2.334v6.11a1.581 1.581 0 0 0 1.593 1.424 1.625 1.625 0 0 0 1.631-1.606V6.762h2.296v7.804Z",
    fill: "#053249"
  })));
};
export default SvgNavBarOwnwellLogo;